import React, { useRef } from 'react';
import LeadForm from '../components/LeadForm';
import { leadFormFields } from '../data/siteContent';

export default function FreeAssessment() {
  const formRef = useRef(null);

  return (
    <div className="bg-gradient-to-br from-primary to-indigo-900 text-white min-h-screen">
      <div className="max-w-5xl mx-auto py-20 px-6 space-y-10">
        <section className="space-y-3">
          <p className="text-xs uppercase tracking-[0.6em] text-white/80">Free Assessment</p>
          <h1 className="text-4xl font-bold">Tax Strategy Assessment</h1>
          <p className="text-lg text-white/80">
            A 15-minute discovery call + questionnaire that returns a documented strategy roadmap for you and your CPA.
          </p>
        </section>

        <div ref={formRef} className="rounded-3xl bg-white/90 p-8 shadow-2xl text-charcoal">
          <LeadForm
            funnelId="funnel_tax_assessment"
            pageId="free_assessment"
            ctaId="cta_free_assessment"
            fields={leadFormFields}
            branding={{ primary_color: '#1e40af', secondary_color: '#AEFFE3' }}
          />
        </div>
      </div>
    </div>
  );
}
